/**
 * Copyright (c) NCR Terafina
 **/
import React, { FormEventHandler, useState } from 'react';
import { Button, Form, Toast, ToastContainer } from 'react-bootstrap';
import { Redirect, useLocation } from 'react-router-dom';
import { AnalyticsService } from './AnalyticsService';
import { AuthService } from './AuthService';
/**
 * Login component
 *
 */
export default function Login() {
  const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  type LocationState = {
    from: Location;
  };

  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const { state } = useLocation<LocationState>();

  const login: FormEventHandler = (event) => {
    AnalyticsService.trackPageView('/login', 'Login');
    event.preventDefault();
    event.persist();
    AuthService.login(password).then((resp) => {
      if (resp) {
        return setRedirectToReferrer(true);
      } else {
        setShow(true);
      }
    });
  };

  if (redirectToReferrer === true) {
    return <Redirect to={state?.from || '/'} />;
  }
  return (
    <div className="tf-login-page">
      <div aria-live="polite" aria-atomic="true" style={{ minHeight: '240px' }}>
        <ToastContainer className="p-3" position="bottom-center">
          <Toast bg="danger" onClose={() => setShow(false)} show={show} delay={3000} autohide>
            <Toast.Header closeButton={true}>
              <strong className="me-auto">Error</strong>
            </Toast.Header>
            <Toast.Body className="danger">Invalid Token</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <div className="tf-login-card">
        <Form onSubmit={login}>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>NPM Token</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="A unique code provided by Terafina"
            />
          </Form.Group>
          <Button className="float-end" size="lg" variant="primary" type="submit">
            Login
          </Button>
        </Form>
      </div>
    </div>
  );
}
